import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import lodash from 'lodash';
import { filterMenuItemsByPermissions } from '../../../../utils/permissionMapper';
import { isTabAllowed } from '../../../../utils/widgetPermissions';

const MenuList = ({ user_role, timeZone, overAllDisplaySettings, isCollapsed, platform, userDashboardPermissions, isSkan }) => {
  const platformFromStorage = localStorage.getItem('platform');

  console.log('Current user role:::::', user_role);
  console.log('Display settings:::::', overAllDisplaySettings);

  const menuItems = useMemo(() => {
    // let menuItemNew = menuItem;
    let menuItemNew = lodash.cloneDeep(menuItem); //Deep copy to avoid mutation issues
    const adminItems = lodash.cloneDeep(menuItem.items.find((item) => item.id === 'admin'));

    console.log('Admin Items___>>>', adminItems);
    console.log('User Permissions___>>>', userDashboardPermissions);

    // Filter menu based on user permissions with current context
    if (userDashboardPermissions && userDashboardPermissions.tabs && userDashboardPermissions.tabs.length > 0) {
      const dataType = isSkan ? 'skan' : 'nonskan';
      console.log('🔍 Sidebar - Filtering menu with permissions:', {
        userDashboardPermissions,
        timeZone,
        dataType,
        tabs: userDashboardPermissions.tabs
      });
      menuItemNew = {
        items: filterMenuItemsByPermissions(menuItemNew.items, userDashboardPermissions, timeZone, dataType)
      };
      console.log('🔍 Sidebar - Filtered menu items:', menuItemNew.items);
    }

    // Filter menu based on user_role and display settings (legacy support)
    if (user_role && user_role !== 'admin' && overAllDisplaySettings) {
      menuItemNew = {
        items: menuItemNew.items.filter((item) => item.id !== 'admin')
      };
      if (!overAllDisplaySettings.creative_report) {
        menuItemNew.items = menuItemNew.items.map((item) => ({
          ...item,
          children: item.children.filter((child) => child.id !== 'creative')
        }));
      }
      if (!overAllDisplaySettings.publisher_app_report) {
        menuItemNew.items = menuItemNew.items.map((item) => ({
          ...item,
          children: item.children.filter((child) => child.id !== 'reporting')
        }));
      }
      if (!overAllDisplaySettings.raw_event_report) {
        menuItemNew.items = menuItemNew.items.map((item) => ({
          ...item,
          children: item.children.filter((child) => child.id !== 'rawevents')
        }));
      }
    }

    // Filter menu based on platform
    const activePlatform = platform || platformFromStorage;
    // if (activePlatform) {
    //   if (activePlatform.includes('IAP') && !activePlatform.includes('DSP')) {
    //     console.log("IAP only ===>", activePlatform);
    //     menuItemNew.items = menuItemNew.items.map(item => ({
    //       ...item,
    //       // children: item.children.filter(child => child.id === 'iap')
    //       children: item.children.filter(child => ['iap-header', 'iap'].includes(child.id))
    //     }));
    //   } else if (activePlatform.includes('DSP') && !activePlatform.includes('IAP')) {
    //     console.log("DSP only ===>", activePlatform);
    //     menuItemNew.items = menuItemNew.items.map(item => ({
    //       ...item,
    //       children: item.children.filter(child => ['dsp-header', 'default', 'creative', 'reporting', 'rawevents', 'wow', 'dod'].includes(child.id))
    //     }));
    //   } else if (activePlatform.includes('IAP') && activePlatform.includes('DSP')) {
    //     console.log("IAP & DSP ===>", activePlatform);
    //     menuItemNew.items = menuItemNew.items.map(item => ({
    //       ...item,
    //       children: item.children.filter(child => ['dsp-header', 'dsp', 'iap-header', 'iap', 'creative', 'reporting', 'rawevents', 'wow', 'dod'].includes(child.id))
    //     }));
    //   }
    // }

    // if (activePlatform) {
    //   menuItemNew.items = menuItemNew.items.map((item) => ({
    //     ...item,
    //     children:
    //       item.id === 'admin'
    //         ? item.children //Preserve admin panel
    //         : item.children?.filter((child) =>
    //           activePlatform.includes('D2C')
    //           ? ['d2c'].includes(child.id)
    //           : activePlatform.includes('IAP') && activePlatform.includes('DSP')
    //               ? ['dsp-header', 'dsp', 'iap-header', 'iap', 'creative', 'reporting', 'rawevents', 'wow', 'dod','d2c'].includes(child.id)
    //               : activePlatform.includes('IAP')
    //               ? ['iap-header', 'iap'].includes(child.id)
    //               : ['dsp-header', 'default', 'creative', 'reporting', 'rawevents', 'wow', 'dod','d2c'].includes(child.id)
    //           ) || []
    //   }));
    // }

    // if (activePlatform) {
    //   menuItemNew.items = menuItemNew.items.map((item) => ({
    //     ...item,
    //     children:
    //       item.id === 'admin'
    //         ? item.children //Preserve admin panel
    //         : item.children?.filter((child) =>
    //             activePlatform.includes('IAP') && activePlatform.includes('DSP')
    //               ? ['dsp-header', 'dsp', 'iap-header', 'iap', 'creative', 'reporting', 'rawevents', 'wow', 'dod','d2c-header',"d2c"].includes(child.id)
    //               : activePlatform.includes('IAP')
    //               ? ['iap-header', 'iap'].includes(child.id)
    //               : ['dsp-header', 'default', 'creative', 'reporting', 'rawevents', 'wow', 'dod','d2c-header',"d2c"].includes(child.id)
    //           ) || []
    //   }));
    // }
    if (activePlatform) {
      menuItemNew.items = menuItemNew.items.map((item) => ({
        ...item,
        children:
          item.id === 'admin'
            ? item.children // Preserve admin panel
            : item.children?.filter((child) => {
                const hasDSP = activePlatform.includes('DSP');
                const hasIAP = activePlatform.includes('IAP');
                const hasD2C = activePlatform.includes('D2C');
                const hasCTV = activePlatform.includes('CTV');
                const hasGTV = activePlatform.includes('GTV');

                const dspSharedItems = ['creative', 'reporting', 'rawevents', 'statereport', 'wow', 'dod'];
                const iapItems = ['iap-header', 'iap'];
                const d2cItems = ['d2c-header', 'd2c'];
                const ctvItems = ['ctv-header', 'ctv'];
                const gtvItems = ['gtv-header', 'gtv'];

                let allowed = [];
                if (hasDSP) {
                  const isMultiPlatform = hasIAP || hasD2C || hasCTV || hasGTV;
                  if (isMultiPlatform) {
                    allowed = allowed.concat(['dsp-header', 'dsp'], dspSharedItems);
                  } else {
                    allowed = allowed.concat(['dsp-header', 'default'], dspSharedItems);
                  }
                }
                if (hasIAP) allowed = allowed.concat(iapItems);
                if (hasD2C) allowed = allowed.concat(d2cItems);
                if (hasCTV) allowed = allowed.concat(ctvItems);
                if (hasGTV) allowed = allowed.concat(gtvItems);

                if (!hasDSP && !hasIAP && !hasD2C && !hasCTV && !hasGTV) {
                  allowed = ['dsp-header', 'default', 'creative', 'reporting', 'rawevents', 'statereport', 'wow', 'dod'];
                }

                return allowed.includes(child.id);
              }) || []
      }));
    }

    // Fix: Add Admin back if it's missing
    if (user_role === 'admin' && adminItems && !menuItemNew.items.some((item) => item.id === 'admin')) {
      console.log('Inside Admin items___>>>');
      menuItemNew = {
        ...menuItemNew,
        items: [...menuItemNew.items, adminItems]
      };
    }
    return menuItemNew;
  }, [user_role, overAllDisplaySettings, platform, platformFromStorage, userDashboardPermissions, timeZone, isSkan]);

  const navItems = menuItems.items.map((item) =>
    item.type === 'group' ? (
      <NavGroup key={item.id} item={item} isCollapsed={isCollapsed} />
    ) : (
      <Typography key={item.id} variant="h6" color="error" align="center">
        Menu Items Error
      </Typography>
    )
  );

  return <>{navItems}</>;
};

const mapStateToProps = (state) => ({
  user_role: state.advertiserReducer.user_type,
  timeZone: state.advertiserReducer.timeZone,
  overAllDisplaySettings: state.userReducer.overAllDisplaySettings,
  platform: state.advertiserReducer.platform,
  userDashboardPermissions: state.userReducer.userDashboardPermissions,
  isSkan: state.campaignReducer.isSkan
});

export default connect(mapStateToProps)(MenuList);
